import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useContractService } from "contexts/ServiceContext";
import { FileUri } from "api";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

const useContractFiles = (
  docEntry: number | undefined,
  currentSort?: { key: keyof FileUri; direction: string }
): UseQueryResult<{
  contracts: ContractFile[];
  statements: ContractFile[];
}> => {
  const contractService = useContractService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    docEntry,
  });
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    docEntry,
  });

  return useQuery({
    queryKey: ["contract-files", { contractNumber: docEntry }, { currentSort }],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "Quotation/GetFileUriList/{DocEntry}",
      });
      return docEntry
        ? contractService
            .getContractFileList(docEntry, currentSort)
            .catch((err) => {
              trackQueryError({ message: err.message }, eventId);
              throw err;
            })
        : Promise.reject();
    },
    enabled: !!docEntry,
    select: (data) => data.value,
  });
};

export default useContractFiles;
